import { useEffect } from "react";
import {
  Form,
  InputNumber,
  Button,
  Typography,
  notification,
  Row,
  Col,
} from "antd";
import { useBoundStore } from "store";
import { useUpdateOrganization } from "organizations/queries";

export const GeneralSettings = () => {
  const [form] = Form.useForm();
  const [api, contextHolder] = notification.useNotification();
  const { currentOrganization } = useBoundStore();
  const updateOrg = useUpdateOrganization();

  useEffect(() => {
    if (currentOrganization) {
      form.setFieldsValue({
        ...currentOrganization.metadata,
      });
    }
  }, [currentOrganization, form]);

  const handleSave = async () => {
    const values = form.getFieldsValue();
    try {
      await updateOrg.mutateAsync({
        salesTargetAmount: values.salesTargetAmount,
        billedProjectsTargetAmount: values.billedProjectsTargetAmount,
        completedProjectsTargetAmount: values.completedProjectsTargetAmount,
        salesTargetYear: values.salesTargetYear,
        salesTargetMonth: values.salesTargetMonth,
        salesTargetQuarter: values.salesTargetQuarter,
      });
      api.success({ duration: 3, message: "Settings Saved" });
    } catch (error: any) {
      api.error({ message: "Error", description: error?.message });
    }
  };

  return (
    <div className="general-settings">
      {contextHolder}
      <Typography.Title className="general-settings-title">General Settings</Typography.Title>
      <Typography.Paragraph type="secondary">Configure organization-level settings and sales targets.</Typography.Paragraph>
      <Form form={form} layout="vertical">
        <Typography.Title level={5}>Sales Targets</Typography.Title>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="salesTargetAmount" label="Sales Target Amount">
              <InputNumber
                prefix="$"
                style={{ width: "100%" }}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "") as any}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="billedProjectsTargetAmount"
              label="Billed Projects Target"
            >
              <InputNumber
                prefix="$"
                style={{ width: "100%" }}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "") as any}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="completedProjectsTargetAmount"
              label="Completed Projects Target"
            >
              <InputNumber
                prefix="$"
                style={{ width: "100%" }}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value?.replace(/\$\s?|(,*)/g, "") as any}
              />
            </Form.Item>
          </Col>
        </Row>

        <Button
          type="primary"
          size="large"
          loading={updateOrg.isPending}
          onClick={handleSave}
        >
          Save Settings
        </Button>
      </Form>
    </div>
  );
};
